import React, { PureComponent } from "react";
import ReactDOM from "react-dom";
import { connect } from "react-redux";
import { Route, Redirect } from "react-router-dom";

import withStyles from "@material-ui/core/styles/withStyles";
import Typography from "@material-ui/core/Typography";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";

import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { Checkbox } from "@material-ui/core";
import Colors from "../../constants/Colors";
import TextField from "@material-ui/core/TextField";
import IphoneMockup from "./IphoneMockup";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import MenuItem from "@material-ui/core/MenuItem";

import Editor from "react-medium-editor";
import EditableInput from "../../components/EditableInput";

import {
  modifyCreation,
  createActionRequest
} from "../../services/action/actions";

// load theme styles with webpack
require("medium-editor/dist/css/medium-editor.css");
require("medium-editor/dist/css/themes/default.css");

const styles = theme => ({
  main: {
    width: "90%",
    flexDirection: "row",
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-start"
  },
  root: {
    marginTop: theme.spacing.unit * 3,
    overflowX: "auto",
    marginBottom: 15
  },
  leftSide: {
    width: "45%",
    minHeight: 700,
    alignItems: "flex-start",
    justifyContent: "flex-start",
    flexDirection: "column",
    display: "flex"
  },
  rightSide: {
    width: "45%",
    alignItems: "center",
    justifyContent: "flex-start",
    flexDirection: "column",
    display: "flex",
    position: "relative",
    minHeight: 800
    // flex: 1
  },
  container: {
    marginTop: theme.spacing.unit * 3,
    marginBottom: 15,
    flex: 1,
    flexDirection: "row",
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between"
  },
  saveButton: {
    marginTop: 15
  },
  title: {
    fontWeight: 500,
    marginTop: 15,
    marginBottom: 15
  },
  appTitleDiv: {
    width: 280,
    backgroundColor: Colors.mediumGreen,
    padding: 15,
    alignItems: "center",
    flexDirection: "column",
    justifyContent: "center",
    borderRadius: 8,
    wordWrap: "break-word"
    // wordWrap: "break-word"
    // maxWidth: 280
  },
  appText: {
    minWidth: "1%",
    textAlign: "center",
    wordWrap: "break-word"
  },
  separator: {
    height: 1,
    marginTop: 5,
    marginBottom: 10,
    width: "45%",
    backgroundColor: Colors.mediumGrey
  },
  separatorContainer: {
    marginTop: 15,
    width: 280,
    display: "flex",
    flexWrap: "wrap",
    wordBreak: "break-all",
    alignItems: "center",
    justifyContent: "flex-start",
    flexDirection: "column"
  },
  content: {
    width: 280,
    marginTop: 80,
    wordWrap: "break-word",
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "center",
    flexDirection: "column"
  },
  formControl: {
    marginTop: 16,
    marginBottom: 8,
    minWidth: 120
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 2
  },
  textEditor: {
    color: "#3A4554",
    cursor: "text",
    display: "inline-flex",
    fontSize: "1rem",
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"'
    ].join(","),
    lineHeight: "1.1875em",
    alignItems: "center",
    minWidth: 120,
    height: "19px",
    marginTop: 16,
    marginBottom: 8,
    width: "100%",
    resize: "none",
    border: "none",
    padding: 0,
    outline: "none",
    boxSizing: "border-box",
    background: "transparent",
    borderColor: "rgba(0, 0, 0, 0.23)",
    borderWidth: "1px",
    borderRadius: "4px"
  },
  editorDiv: {
    padding: "18.5px 14px"
    // borderStyle: "solid",
    // borderWidth: "1px",
    // borderRadius: "4px",
    // padding: "18.5px 14px",
    // boxSizing: "border-box"
  },
  label: {
    color: Colors.blackGrey,
    fontSize: "1em"
  },
  border: {
    position: "absolute",
    bottom: 0,
    left: 0,
    height: "2px",
    width: "100%",
    background: "#0077FF",
    transform: "scaleX(0)",
    transformOrigin: "0 0",
    transition: "all .15s ease"
  }
});

const isNumber = n => {
  return !isNaN(parseFloat(n)) && isFinite(n);
};

class Creation extends PureComponent {
  state = {
    expanded: null,
    labelWidth: 0
  };

  componentDidMount() {
    this.setState({
      labelWidth: ReactDOM.findDOMNode(this.InputLabelRef).offsetWidth
    });
  }

  handleChange = name => value => {
    // prevent bug from plugin to apply style="" in the HTML
    const newValue = value.replace(/ style="(.*?)"/gm, "");
    this.props.modifyCreation({
      [name]: newValue
    });
  };

  handleCategoryChange = event => {
    const value = event.target.value;
    this.props.modifyCreation({
      category: value
    });
  };

  onSubmit = () => {
    const { how, title, why, clientId, category } = this.props;
    this.props.createActionRequest({ how, title, why, clientId, category });
  };

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.main}>
        <div className={classes.container}>
          <div className={classes.leftSide}>
            <p className={classes.label}>Titre de l'action</p>
            <EditableInput
              text={this.props.title}
              placeholder={"Titre de l'action"}
              onChange={this.handleChange("title")}
            />
            <p className={classes.label}>Pourquoi ?</p>
            <EditableInput
              text={this.props.why}
              placeholder={"Pourquoi ?"}
              onChange={this.handleChange("why")}
            />
            <p className={classes.label}>Exemples concrets</p>
            <EditableInput
              text={this.props.how}
              placeholder={"Exemples concrets"}
              onChange={this.handleChange("how")}
            />

            <FormControl variant="outlined" className={classes.formControl}>
              <InputLabel
                ref={ref => {
                  this.InputLabelRef = ref;
                }}
                htmlFor="outlined-age-native-simple"
              >
                Catégorie
              </InputLabel>
              <Select
                native
                value={this.props.category}
                onChange={this.handleCategoryChange}
                input={
                  <OutlinedInput
                    name="Catégorie"
                    labelWidth={this.state.labelWidth}
                    id="outlined-age-native-simple"
                  />
                }
              >
                {/* <option value="" /> */}
                <option value={"leadership"}>Leadership</option>
                <option value={"teamCohesion"}>Cohésion d'équipe</option>
                <option value={"proactivity"}>Pro-activité</option>
                <option value={"resilience"}>Résilience</option>
                <option value={"publicSpeaking"}>Capacité à convaincre</option>
              </Select>
            </FormControl>
            {this.props.requesting ? (
              <CircularProgress />
            ) : (
              <Button
                onClick={this.onSubmit}
                variant="contained"
                disabled={this.props.title === ""}
                fullWidth
                color="primary"
                className={classes.saveButton}
              >
                Créer cette action
              </Button>
            )}
          </div>
          <Paper className={classes.rightSide}>
            <Typography variant="h5" className={classes.title}>
              Rendu sur l'application
            </Typography>
            <div style={{ position: "absolute", top: 60 }}>
              <IphoneMockup />
            </div>
            <div className={classes.content}>
              {this.props.title && (
                <div className={classes.appTitleDiv}>
                  <Typography
                    className={classes.appText}
                    dangerouslySetInnerHTML={{ __html: this.props.title }}
                  >
                    {/* {this.props.title} */}
                  </Typography>
                </div>
              )}
              {this.props.why && (
                <div className={classes.separatorContainer}>
                  <Typography variant="h6">Pourquoi ?</Typography>
                  <div className={classes.separator} />
                  <Typography
                    className={classes.appText}
                    dangerouslySetInnerHTML={{ __html: this.props.why }}
                  />
                </div>
              )}
              {this.props.how && (
                <div className={classes.separatorContainer}>
                  <Typography variant="h6">Exemples concrets</Typography>
                  <div className={classes.separator} />
                  <Typography
                    className={classes.appText}
                    dangerouslySetInnerHTML={{ __html: this.props.how }}
                  />
                </div>
              )}
            </div>
          </Paper>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const {
    selectionList,
    allActions,
    requesting,
    tabSelected,
    title,
    how,
    why,
    category
  } = state.action;
  const { clientId } = state.client;
  return {
    token: state.auth.token,
    clientId,
    selectionList,
    allActions,
    requesting,
    tabSelected,
    title,
    how,
    why,
    category
  };
};

export default connect(
  mapStateToProps,
  {
    createActionRequest,
    modifyCreation
  }
)(withStyles(styles)(Creation));
